CntrlReceipt.$inject = [
    '$state',
    '$rootScope',
    '$scope',
    '$timeout',
    '$stateParams',
    '$interval',
    'PortalApi',
    'Notification',
    'Authentication',
    'Analytics',
    'Locations',
    '$translate',
    'Pay'
];

function CntrlReceipt($state, $rootScope, $scope, $timeout, $stateParams, $interval, PortalApi, Notification, Authentication, Analytics, Locations, $translate, Pay) {
    var BigNumber = require('bignumber.js');

    var count = 0;
    var maxCount = 100;

    $scope.whatFrame = Authentication.frameLogin;
    $scope.paymentId = $stateParams.payment_id;
    $scope.preLoader = true;
    $scope.service_id = $stateParams.service_id;
    // $scope.service_id = 10052; -- test dev receipt
    $scope.service_furl = $stateParams.service_furl;
    // $scope.service_furl = 'p2p'; // for test
    $scope.state = '';
    $scope.showPrintForm = false;
    $scope.userAuth = Authentication.isLogged;
    $scope.payment = {
        status: ''
    };
    $scope.category = $stateParams.category_id;

    if(!$scope.userAuth){
        if($scope.paymentId == 'cardtocard'){
            $scope.category = 'p2p';
            $scope.categoryClass = 'p2p';
            $scope.finText = 'SECURE';
        }else{
            switch ($scope.category) {
                case 33://mobile category
                    $scope.categoryClass = 'mob';
                    $scope.finText = 'COMFORT';
                    break;
                case 34://internet and tv category
                    $scope.categoryClass = 'internet';
                    $scope.finText = 'MONEY';
                    break;
                case 37://communal payments category
                    $scope.categoryClass = 'home';
                    $scope.finText = 'MONEY';
                    break;
                case 39://webmoney category
                    $scope.categoryClass = 'webmoney';
                    $scope.finText = 'COMFORT';
                    break;
                case 40://games category
                    $scope.categoryClass = 'games';
                    $scope.finText = 'COMFORT';
                    break;
                default://other categories
                    $scope.categoryClass = 'base';
                    $scope.finText = 'ALL';
            }
        }
    }

    function getGaTrnName(paymentId) {
        var prefix = [];
        var app = 'PH';
        var opt = 'JD';

        if ($rootScope.admitad_uid) {
            app = 'ADMD';
        }

        if ($rootScope.useFrame) {
            app = 'F';
            opt = String(Authentication.frameLogin).replace(/[^A-z]/g, '').toUpperCase();

        } else if (Authentication.isLogged) {
            opt = 'AUTH';
        }

        prefix.push(app);
        prefix.push(opt);
        prefix.push(paymentId);

        return prefix.join('_');
    }

    $scope.getStatus = function() {
        $scope.preLoader = true;

        PortalApi.getPaymentStatus(
            [$stateParams.payment_id]
        ).then(function(response) {
            var response = response.plain(); //[0][1];
            var status = '';
            count++;

            $scope.payment.status = '';

            var errorText = response && !Array.isArray(response)
                && (response.error_text || (response.data && response.data.error_text));
            if (errorText) {
                $scope.payment.status = 'failed';
                $scope.succ = false;
                $scope.preLoader = false;
                Pay.apiError(errorText, 10);
                return;
            }

            if (!Array.isArray(response)
                || !response.length
                || ['failed', 'reverted', 'reverted_failed'].indexOf(response[0][1]) !== -1
            ) {
                $scope.payment.status = 'failed';
                $scope.succ = false;

                return $translate('DICTIONARY.ERROR').then(function (translation) {
                    Pay.apiError(translation + ' ' + $stateParams.payment_id);
                    $scope.preLoader = false;
                });
            }

            status = response[0][1];
            if (count >= maxCount) {
                $scope.payment.status = 'error';

                $scope.succ = false;
                return $translate('NOTIFICATION.ERROR.CHECK_STATUS_LIMIT').then(function (translation) {
                    Pay.apiError(translation);
                });
            } else {
                $scope.payment.status = 'processing';
                switch (status) {
                    case 'processing':
                    case 'confirmed':
                        return $timeout(function() {
                            $scope.getStatus();
                        }, 2000);
                        break;
                    case 'processed':
                        $scope.payment.status = 'processed';
                        $scope.getReceipt();

                        $rootScope.lastPayment = {
                            id: $stateParams.payment_id,
                            category_id: $stateParams.category_id,
                            category_name: $stateParams.category_name
                        };
                        break;
                    default:
                        $scope.payment.status = 'failed';

                        $scope.preLoader = false;
                        // $.notify('Сталася помилка');
                        $translate('ERRORS.UNKNOWN_ERROR').then(function (translation) {
                            Notification.error({
                                message: translation,
                                delay: true
                            });
                        });
                        break;
                }
            }

        });

    };

    $scope.getReceipt = function() {
        PortalApi.getPaymentReceipt($stateParams.payment_id).then(function(response) {
            var response = response.plain();

            if (typeof(response) != "object" || response.status === 'error') {
                $scope.succ = false;
                return $scope.apiError(
                    'Досягнуто максимальну кільк. спроб.',
                    true
                );
            }

            $scope.succ = true;
            $scope.preLoader = false;
            $scope.payment = response;
            $scope.sum = new BigNumber(response.amount).toFixed(2);

            Analytics.addProduct(
                String($stateParams.payment_id),
                response.name,
                '',
                '',
                '',
                $scope.sum,
                '1'
            );

            switch ($scope.category) {
                case 33://mobile category
                case 38://credits category
                case 'p2p'://p2p service
                    Analytics.trackEvent('', '', '', '', '', {
                        hitType: 'event',
                        eventCategory: $scope.category == 38 ? 'loan' : $scope.categoryClass,
                        eventAction: $scope.sum,
                        eventLabel: $scope.category == 33 ? Pay.data.searchServices.name : ''
                    });
                    break;
            }

            Analytics.trackTransaction(
                getGaTrnName($stateParams.payment_id),
                'PAYHUB',
                new BigNumber(response.amount).plus(response.commission || 0).toFixed(2),
                new BigNumber(response.commission || 0).toFixed(2),
                '0'
            );

            Analytics.pageView();

            if (response.confirm_data.CH2) {
                $scope.payment.name_to  = response.confirm_data.CH2.receiver;
            }
        });
    };

    $scope.apiError = function(errorText) {
        $scope.preLoader = false;

        return $translate('NOTIFICATION.ERROR.UNKNOWN_ERROR').then(function(transform1) {
            Notification.error({
                message: errorText || transform1,
            });
        });
    };

    $scope.rePay = function (payment) {
        if ($scope.service_furl == "p2p") {
            $state.go('pages.cardtocard', {});
        } else {
            $state.go('pages.payment', {
                serviceId: $scope.service_id,
                url: $scope.service_furl || $scope.service_id,
                amount: payment.amount,
                fields: payment.fields,
                templateId:true,
                autoCheck: false
            });
        }
    };

    $scope.getStatus();
}

module.exports = CntrlReceipt;



/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/receipt/controllers/receipt.controller.js
 ** module id = 284
 ** module chunks = 1
 **/